// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Popover, OverlayTrigger } from 'praece-react-bootstrap';
import _ from 'lodash';
import { alerts } from 'modules/alerts/actions';
// import { Link } from 'react-router';

// Actions
import * as authActions from 'modules/auth/actions';

// Services
import Person from 'services/data/person';
import * as socket from 'services/socket';

// Components
import SVG from 'components/widgets/icons/svg';
// import SSO from 'components/widgets/sso/sso';
import Tooltip from 'components/widgets/overlays/tooltip';

// Constants
import { isMobile } from 'constants';


class CurrentUser extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    teams: PropTypes.array
  };

  constructor() {
    super();
    this.switchOnCall = this.switchOnCall.bind(this);
    this.getSubmenu = this.getSubmenu.bind(this);
    this.updateUser = this.updateUser.bind(this);
  }

  componentDidMount() {
    socket.registerSocket('user', this.updateUser);
  }

  switchOnCall() { // eslint-disable-line react/sort-comp
    const { currentUser } = this.props;

    Person.update({ id: currentUser.id, onCall: !currentUser.onCall })
      .then(this.updateUser)
      .catch(alerts.catchError);
  }

  getSubmenu({ user }) { // eslint-disable-line no-unused-vars
    return (
      <Popover id="current-user-popover" className="submenu">
        <ul>
        {/* Add back in once SSO is ready to launch
          <span>SSO</span>
          <SSO />
          <hr />
        */}
       {/* Add back in when we launch users
          <li>
            <Link to={`/users/edit/${user.id}`} className="unadorned">Profile</Link>
          </li>
        */}
          <li onClick={authActions.logout}>Log out</li>
        </ul>
      </Popover>
    );
  }

  updateUser(updatedUser) {
    const { currentUser } = this.props;

    // If the updated user isn't the current user skip the update
    if (updatedUser.id !== currentUser.id) return;
    if (_.isEqual(_.omit(updatedUser, ['updatedAt']), _.omit(currentUser, ['updatedAt']))) return;

    authActions.updateCurrentUser({ ...currentUser, ...updatedUser });
  }

  render() {
    const { currentUser, teams } = this.props;

    if (_.isEmpty(currentUser)) return null;

    const teamId = _.get(currentUser, 'team.id', currentUser.team);
    const userTeam = _.find(teams, { id: teamId });
    const teamColor = (userTeam || {}).color;
    let styles = teamColor ? { backgroundColor: teamColor, borderColor: teamColor } : {};
    if (!currentUser.onCall) styles = { backgroundColor: '#7f8c8d', borderColor: '#7f8c8d' };

    return (
      <div className="current-user no-select">
        <Tooltip
          title={`Go ${currentUser.onCall ? 'off' : 'on'} call`}
          placement="bottom"
          tooltipClasses="menu-tooltip"
          style={styles}
          className="on-call-indicator"
          onClick={this.switchOnCall}
        >
          <SVG src={`svg/${currentUser.onCall ? 'on' : 'off'}-call.svg`} />
        </Tooltip>
        <div className="grow current-user-name">
          {Person.fullName(currentUser)}
          <div className="deemphasize">{currentUser.billingRole}</div>
        </div>
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          rootClose={!isMobile}
          overlay={this.getSubmenu({ user: currentUser })}
        >
          <SVG src="svg/expand.svg" className="hoverable expand" />
        </OverlayTrigger>
      </div>
    );
  }
}

// Exports
export default connect((state) => ({
  currentUser: state.auth.currentUser,
  teams: state.pageData.teams
}))(CurrentUser);



// WEBPACK FOOTER //
// ./app/components/main-menu/components/current-user.js